import React from 'react';

import Badge from '../Badge';

function BetaBadge() {
  return <Badge intent="warning">Beta</Badge>;
}

export default BetaBadge;
